<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<div v-if="false" class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					<img class="img1" src="../../assets/img_zt/icon_1.webp" />&nbsp;
					<img class="img2" src="../../assets/img_zt/icon_2.webp" />&nbsp;
					Happy 4th of July!
				</div>
				<div class="txt">
					Use code <span>CorDx21</span> at checkout to get <span>21% off</span> your purchase on  
					<a style="color: #2173FF !important;font-weight: bold;text-decoration: underline;" href="https://al21.com/products/cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test">AL21</a>,
					&nbsp;&nbsp;&nbsp;<img class="img1" style="top: 4px;" src="../../assets/img_zt/icon_3.webp" />&nbsp;
					Special July 4th One-Day Sale: <span>21% Off</span> on
					<a style="color: #2173FF !important;font-weight: bold;text-decoration: underline;" href="https://www.amazon.com/At-Home-CorDx-COVID-19-Accurate-Results/dp/B0D2DQBJS2?maas=maas_adg_EAA5E1BA3E43283FC76983FA6B2A9AFF_afap_abs&ref_=aa_maas&tag=maas">Amazon</a>.
					
				</div>
			</div>
			<!--导航-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe class="my-swipe" :show-indicators="false" :stop-propagation="false" :loop="true" :autoplay="5000" ref="swipeDom"  @change="spChange">
					<van-swipe-item>
						<div class="swiper_el" style="padding-bottom: 20px;">
							<img class="txt1" style="width: 100%;" src="../../assets/banner/h5/20251009/banner_RSV_bg_yd.webp" />
							<div class="msg_box" style="position: absolute;top: 30px;left: 0;">
								<img class="txt1" src="../../assets/banner/h5/20251009/banner_RSV_product_yd.webp" style="width: 86%;margin-left: 7%;" />
								<img class="txt2" src="../../assets/banner/h5/20251009/banner_RSV_text_yd.webp" style="position: relative;top: 20px;" />
								<div class="btn_box_box">
									<!-- <img class="btn1" src="../../assets/banner/PC/20251009/RSV_btn.webp" style="width: 45%;position: relative;top: 20px;" @click="goBanner(10)" /> -->
									<img class="btn1" src="../../assets/banner/PC/20251009/more.webp" style="width: 40%;position: relative;top: 20px;" @click="goBanner(11)" />
								</div>
							</div>
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="swiper_el">
							<img class="txt1" style="width: 100%;" src="../../assets/banner/h5/p.webp" />
							<div class="msg_box">
								<img class="txt1" src="../../assets/banner/h5/3659.webp" />
								<div class="btn_box_box">
									<img class="btn1" src="../../assets/banner/h5/button_01.webp" @click="goBanner(3)" />
									<img class="btn2" src="../../assets/banner/h5/button_02.webp" @click="goBanner(4)" />
								</div>
							</div>
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="swiper_el">
							<img class="bg" src="../../assets/banner/h5/20250728/2.webp" />
							<div class="txt_box">
								<div class="tit" style="font-size: 40px;font-weight: bold;padding: 10px 0 5px 0;text-align: center;">
									Sperm Check
								</div>
								<div style="font-size: 22px;padding-bottom: 5px;color: #0B318F;text-align: center;">
									Asperm Home Motility Analyzer
								</div>
								<div style="color: #0B318F;text-align: center;">
									The Asperm Analyzer is a compact,  user-friendly device designed for at-home male fertility testing. With built-in temperature control and Al driven image analysis via mobile app,  it delivers fast and reliable results in under 5 minutes.
								</div>
								<div class="tit" style="font-size: 22px;font-weight: bold;padding: 20px 0 5px 0;text-align: center;">
									Sperm Concentration Test (SP10)<br />(Strip, Cassette)
								</div>
								<div style="color: #0B318F;text-align: center;">
									The Sperm Concentration Test SP10 (Strip, Cassette) provides qualitative detection of semen sperm SP10 proteins in human semen specimen
								</div>
							</div>
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="swiper_el" style="padding-bottom: 20px;">
							<img class="txt1" style="width: 100%;" src="../../assets/banner/h5/20241231/bg.webp" />
							<div class="msg_box" style="position: absolute;top: 20px;left: 0;">
								<img class="txt1" src="../../assets/banner/h5/20241231/text.webp" />
								<div class="btn_box_box" style="text-align: center;">
									<img class="btn1" src="../../assets/banner/h5/20241231/btn.webp" style="width: 60%;" @click="goBanner(2)" />
								</div>
							</div>
						</div>
					</van-swipe-item>
					<van-swipe-item>
						<div class="swiper_el">
							<img class="bg" src="../../assets/img_zt/20240828/h5/bg.webp" />
							<div class="txt_box">
								<div class="tit" style="font-size: 30px;padding-bottom: 20px;">
									$21 Million Gift to UC San Diego Honors Unique Efforts to Link Chemical and Nano Engineering More Strongly
								</div>
							</div>
							<div class="btn_box_ty btn_box" @click="goBanner(7)">
								Learn More<img src="../../assets/img_h5/组 32@2x.png" />
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
				<div class="sp_buttons">
					<div class="btn_el" :class="nowIndex == 0 ? 'actived' : ''" @click="checkBanner(0)"></div>
					<div class="btn_el" :class="nowIndex == 1 ? 'actived' : ''" @click="checkBanner(1)"></div>
					<div class="btn_el" :class="nowIndex == 2 ? 'actived' : ''" @click="checkBanner(2)"></div>
					<div class="btn_el" :class="nowIndex == 3 ? 'actived' : ''" @click="checkBanner(3)"></div>
					<div class="btn_el" :class="nowIndex == 4 ? 'actived' : ''" @click="checkBanner(4)"></div>
				</div>
			</div>
			<!--banner-->
			<!--广告块-->
			<!-- <div v-if="false" class="adver_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="adver_main">
					<div class="adver_el" style="cursor: pointer;" @click="goFreeSample">
						<img class="icon" src="../../assets/img_public/icon_1.png" />
						<div class="tit">Free Sample</div>
					</div>
					<div class="adver_el" style="position: relative;top: 8px;">
						<img class="icon" src="../../assets/img_public/icon_2.png" />
						<div class="tit">Promotion Codes & Coupons</div>
					</div>
					<div class="adver_el">
						<img class="icon" src="../../assets/img_public/icon_3.png" />
						<div class="tit">Quick Order</div>
					</div>
					<div class="adver_el">
						<img class="icon" src="../../assets/img_public/icon_4.png" />
						<div class="tit">Get Support</div>
					</div>
				</div>
			</div> -->
			<!--广告块-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="mark"></div>
				<div class="block_1_el">
					<img class="bg" src="../../assets/img_h5/image@2x.webp" />
					<div class="tit">World-Class Diagnostics</div>
					<div class="txt">
						CorDx pushes the limits of innovation in global health. We empower families and healthcare providers around the world with rapid, accurate, and reliable diagnostic solutions, all with a dedication to quality.
					</div>
					<div class="btn_box_f">
						<div class="btn_box_ty btn_box" @click="goDiagnostics">
							Learn More<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
				</div>
				<div class="block_1_el">
					<img class="bg" src="../../assets/img_h5/蒙版组 1@2x.webp" />
					<div class="tit">World-Class Supply Chain</div>
					<div class="txt">
						We ensure diagnostics products are available to those who need them, when they need them. Our integrated supply chain removes barriers to accessibility and provides cost savings, flexibility, and more.
					</div>
					<div class="btn_box_f">
						<div class="btn_box_ty btn_box" @click="goSupplyChain">
							Learn More<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_2_el">
					<img class="bg" src="../../assets/img_h5/组 741@2x.webp" />
					<div class="tit">About CorDx​</div>
					<div class="txt">
						CorDx is transforming the global diagnostics industry with innovative R&D solutions, a vertically integrated supply chain, and manufacturing footprints in the US and around the world.
					</div>
					<div class="btn_box_ty btn_box" @click="goAbout">
						Learn More<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
				<div class="block_2_el">
					<img class="bg" src="../../assets/img_h5/图像 1@2x.webp" />
					<div class="tit">Partnerships​</div>
					<div class="txt">
						We partner with organizations around the world to develop, manufacture, and supply diagnostics that empower users to monitor and improve their health.
					</div>
					<div class="txt">	
						Do you have a breakthrough you believe will benefit from collaboration with CorDx?
					</div>
					<div class="btn_box_ty btn_box" @click="goPartnering">
						Partner with CorDx<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
				<div class="block_2_el">
					<img class="bg" src="../../assets/img_h5/image@2x (2).webp" />
					<div class="tit">CorDx Union​</div>
					<div class="txt">
						CorDx is a CorDx Union company, a biotechnology organization that delivers medical device solutions to healthcare industries and over a billion users in more than 170 countries.
					</div>
					<div class="btn_box_ty btn_box" @click="goAbout">
						Learn More<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Recent News</div>
				<div class="news_box">
					<div class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
						<van-icon name="arrow-left" color="#ffffff" size="21px" />
					</div>
					<div class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
						<van-icon name="arrow" color="#ffffff" size="21px" />
					</div>
					<van-swipe class="my-swipe" :show-indicators="true" :loop="true" :autoplay="3000" indicator-color="#0B318F" ref="swipeDom2" :stop-propagation="false">
						<van-swipe-item v-for="(value, index) in newsData" :key="index">
							<div class="swiper_el" @click="goResourcesInfo(value)">
								<img class="bg" :src="value.image" />
								<div class="txt_box">
									<div class="tit">{{ value.title }}</div>
									<div class="time">{{ value.fabu_time }}</div>
								</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="btn_box_f">
					<div class="btn_box_ty btn_box" @click="goResources">
						View More<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Additional Resources</div>
				<div class="block_4_el" @click="goMediaRoom">
					<img class="bg" src="../../assets/img_h5/蒙版组 1@2x.webp" />
					<div class="tit">
						Media room​
						<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
					<div class="txt">
						Read the latest CorDx news, download our press kit, and access other resources tailored for the needs of journalists.
					</div>
				</div>
				<div class="block_4_el" @click="goProducts">
					<img class="bg" src="../../assets/img_h5/蒙版组 1@2x (1).webp" />
					<div class="tit">
						Products
						<img src="../../assets/img_h5/组 32@2x.png" />
					​</div>
					<div class="txt">
						Our proprietary line of diagnostics solutions is recognized by families and medical professionals for their reliability, affordability, and rapid results.
					</div>
				</div>
				<div class="block_4_el" @click="goCareers">
					<img class="bg" src="../../assets/img_h5/蒙版组 1@2x (2).webp" />
					<div class="tit">
						Careers
						<img src="../../assets/img_h5/组 32@2x.png" />
					​</div>
					<div class="txt">
						We’re hiring! Work with the exceptional team that is transforming the diagnostics industry. Explore opportunities to build your career with CorDx.
					</div>
				</div>
			</div>
			<!--块4-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
			<!--广告块-->
			<!-- <div v-if="isFreeShow" class="free_fixed"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="300"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="free_1" src="../../assets/img_public/icon_free_h5.webp" @click="goFreeSample" />
				<img class="free_2" src="../../assets/img_public/icon_close.webp" @click="isFreeShow = false;" />
			</div> -->
			<!--广告块-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			nowIndex: 0,  //当前banner索引
			newsData: JSON.parse(sessionStorage.getItem('newsData')),
			isFreeShow: true,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击酒会注册
		goZc() {
			let that = this;
			window.location.href = 'https://cordx.com/ADLM/202507/index.html#/index';
		},
		//点击查看goFreeSample详情
		goFreeSample() {
			this.$router.push({ path: '/free-sample', });
		},
		bannerLeftClick(value) {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeDom2.prev();
		},
		bannerRightClick(value) {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeDom2.next();
		},
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			//that.$router.push({ path: '/resources-info', query: { id: value.unionid, } });
			that.$router.push({ name: 'Resourcesinfo', params: { resourcesInfoId: value.custom, } });
		},
		//轮播切换
		spChange(index) {
			let that = this;
			switch(index) {
				case 0:
					//that.bannerTit = 'Transforming  Global Diagnostics';
					that.nowIndex = 0;
				break;
				case 1:
					//that.bannerTit = 'CorDx Receives FDA Emergency Use Authorization for Its COVID-19 Antigen Test for OTC Home Use';
					that.nowIndex = 1;
				break;
				case 2:
					//that.bannerTit = 'CorDx Receives FDA Emergency Use Authorization for Its COVID-19 Antigen Test for OTC Home Use';
					that.nowIndex = 2;
				break;
				case 3:
					//that.bannerTit = 'CorDx Receives FDA Emergency Use Authorization for Its COVID-19 Antigen Test for OTC Home Use';
					that.nowIndex = 3;
				break;
				case 4:
					//that.bannerTit = 'CorDx Receives FDA Emergency Use Authorization for Its COVID-19 Antigen Test for OTC Home Use';
					that.nowIndex = 4;
				break;
			}
		},
		//切换banner
		checkBanner(index) {
			let that = this;
			switch(index) {
				case 0:
					//that.bannerTit = 'Transforming  Global Diagnostics';
					that.nowIndex = 0;
					that.$refs.swipeDom.prev();
				break;
				case 1:
					//that.bannerTit = 'CorDx Receives FDA Emergency Use Authorization for Its COVID-19 Antigen Test for OTC Home Use';
					that.nowIndex = 1;
					that.$refs.swipeDom.next();
				break;
				case 2:
					//that.bannerTit = 'CorDx Receives FDA Emergency Use Authorization for Its COVID-19 Antigen Test for OTC Home Use';
					that.nowIndex = 2;
					that.$refs.swipeDom.next();
				break;
				case 3:
					//that.bannerTit = 'CorDx Receives FDA Emergency Use Authorization for Its COVID-19 Antigen Test for OTC Home Use';
					that.nowIndex = 3;
					that.$refs.swipeDom.next();
				break;
				case 4:
					//that.bannerTit = 'CorDx Receives FDA Emergency Use Authorization for Its COVID-19 Antigen Test for OTC Home Use';
					that.nowIndex = 4;
					that.$refs.swipeDom.next();
				break;
			}
		},
		goBanner(index) {
			let that = this;
			switch (index){
				case 0:
					window.location.href = 'https://al21.com/products/cordx-tyfast-covid-19-ag-rapid-test';
					break;
				case 1:
					// let routeData = that.$router.resolve({name: "Productsinfo", params: { productInfoId: 'cordx-covid-19-ag-test' } });
					// window.open(routeData.href, '_blank');
					that.$router.push({ name: 'Productsinfos3', params: { productInfoIds: 'cordx-tyfast-covid-19-ag-rapid-test' } });
					break;
				case 2:
					that.$router.push({ path: '/partnering', });
					break;
				case 3:
					// that.$router.push({ name: 'Productsinfos', params: { productInfoIds: 'cordx-tyfast-flu-a/b-&-covid-19-multiplex-rapid-test', } });
					// window.location.href = 'https://pages.cordx.com/free-sample-kit';
					that.$router.push({ path: '/free-sample-kit', });
					break;
				case 4:
					that.$router.push({ name: 'Productsinfos2', params: { productInfoIds: 'cordx-tyfast-flu-a-b-covid-19-at-home-rapid-multiplex-test-cordx', } });
					break;
				case 5:
					window.location.href = 'https://www.amazon.com/At-Home-CorDx-COVID-19-Accurate-Results/dp/B0D2DQBJS2?maas=maas_adg_EAA5E1BA3E43283FC76983FA6B2A9AFF_afap_abs&ref_=aa_maas&tag=maas';
					break;
				case 6:
					window.location.href = 'https://al21.com/products/cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test';
					break;
				case 7:
					window.location.href = 'https://today.ucsd.edu/story/21-million-gift-to-uc-san-diego-honors-unique-efforts-to-link-chemical-and-nano-engineering-more-strongly';
					break;
				case 8:
					window.location.href = 'https://www.amazon.com/CorDx-at-Home-COVID-19-Accurate-Minutes/dp/B0DCGQD733/ref=sr_1_2?dib=eyJ2IjoiMSJ9.qPIqXjUO2rxpoT5h05pWhQx6kDgP_v0uorAD6GWXNf8.EKhTgxT-iw6B5dzlM91jcO7Zpw9mTBvmXzxfRY8WDrA&dib_tag=se&m=A1EZ8UG06NJCKU&marketplaceID=ATVPDKIKX0DER&qid=1724849517&s=merchant-items&sr=1-2';
					break;
				case 9:
					// window.location.href = 'https://pages.cordx.com/become-a-distributor';
					that.$router.push({ path: '/become-a-distributor' });
					break;
				case 10:
					// window.location.href = 'https://pages.cordx.com/become-a-distributor';
					// that.$router.push({ path: '/contact' });
					// window.location.href = 'https://page.cordx.com/rsv/';
					break;
				case 11:
					window.location.href = 'https://page.cordx.com/rsv/';
					// that.$router.push({ name: 'Productsinfos5', params: { productInfoIds: 'cordx-tyfast-rsv-rapid-test' } });
					break;
			}
		},
		goDiagnostics() {  //供应链详情
			this.$router.push({ path: '/diagnostics', });
		},
		goSupplyChain() {  //诊断详情
			this.$router.push({ path: '/supply-chain', });
		},
		goAbout() {
			this.$router.push({ path: '/about', });
		},
		goPartnering() {
			this.$router.push({ path: '/partnering', });
		},
		goResources() {
			this.$router.push({ path: '/resources', });
		},
		goMediaRoom() {
			this.$router.push({ path: '/media-room', });
		},
		goProducts() {
			this.$router.push({ path: '/product/all', });
		},
		goCareers() {
			this.$router.push({ path: '/careers', });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	.tips_box{
		padding: 16px 45px 14px 45px;
		background-color: #FFF6E2;
		text-align: center;
		.txt{
			padding-top: 8px;
			font-size: 16px;
			line-height: 1.7;
			span{
				font-weight: bold;
			}
		}
		.img1{
			width: 18px;
			position: relative;
			top: -2px;
		}
		.img2{
			width: 22px;
			position: relative;
			top: 2px;
		}
		.tit{
			color: #E15A00;
			font-size: 16px;
			font-weight: bold;
		}
	}
	.free_fixed{
		position: fixed;
		bottom: 0;
		z-index: 9;
		.free_1{
			width: 100%;
			cursor: pointer;
		}
		.free_2{
			position: absolute;
			right: 10px;
			top: 10px;
			width: 30px;
			cursor: pointer;
			z-index: 1;
		}
	}
	/*轮播*/
	.banner_box{
		width: 100%;
		position: relative;
		.sp_buttons{
			position: absolute;
			left: 50%;
			bottom: -5px;
			transform: translate(-50%, 0);
			.actived{
				background-color: #0B318F;
			}
			.btn_el{
				display: inline-block;
				width: 8px;
				height: 8px;
				margin: 8px 4px 0 4px;
				border: 1px solid #0B318F;
				border-radius: 50%;
				cursor: pointer;
			}
		}
		.swiper_el{
			position: relative;
			.right_icon{
				position: absolute;
				top: 0;
				right: 0;
				z-index: 1;
				width: 35%;
			}
			.msg_box{
				position: relative;
				z-index: 1;
				padding: 20px;
				.btn_box_box2{
					padding-top: 24px;
					padding-bottom: 34px;
					img.btn3{
						width: 80%;
					}
				}
				.btn_box_box{
					padding-top: 24px;
					img.btn2{
						width: 40%;
					}
					img.btn1{
						width: 51%;
						margin-right: 20px;
					}
				}
				.txt2{
					margin-top: 20px;
					width: 85%;
				}
				.txt1{
					width: 100%;
				}
			}
			.bg_spec{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
			.btn_box{
				margin: 0 0 20px 20px;
			}
			.txt_box{
				padding: 20px;
				.tit{
					font-size: 30px;
					color: #0B318F;
				}
			}
			img.bg{
				width: 100%;
			}
		}
	}
	/*广告*/
	.adver_box{
		padding: 16px 0 16px 0;
		background: linear-gradient( 90deg, #3A9AFF 0%, #0066D4 100%);
		.adver_main{
			width: 100%;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #BBDBFF;
			.adver_el{
				flex: 1;
				text-align: center;
				.tit{
					padding-top: 10px;
					font-size: 12px;
				}
				.icon{
					width: 24px;
					height: auto;
				}
			}
		}
	}
	/*块4*/
	.block_4{
		height: 1530px;
		padding: 0 20px 50px 20px;
		.block_4_el{
			padding-bottom: 34px;
			.txt{
				padding: 0;
				font-size: 18px;
			}
			.tit{
				position: relative;
				padding: 20px 0rem 16px 0rem;
				font-size: 24px;
				img{
					width: 21px;
					position: absolute;
					right: 0;
				}
			}
			img.bg{
				width: 100%;
			}
		}
		.title{
			padding-bottom: 64px;
			font-size: 36px;
		}
	}
	/*块3*/
	.block_3{
		height: 795px;
		padding: 42px 20px 120px 20px;
		background-image: linear-gradient(180deg, #F1ECE6 20%, #FFFFFF 100%);
		.btn_box{
			margin: 42px 0 0 0;
		}
		.news_box{
			.swiper_el{
				padding-bottom: 25px;
				background-color: #FFFFFF;
				//box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
				.txt_box{
					padding: 20px;
					.time{
						padding-top: 30px;
						font-size: 18px;
						color: #706B69;
					}
					.tit{
						font-size: 22px;
					}
				}
				img.bg{
					width: 100%;
					height: auto;
					object-fit: cover;
				}
			}
		}
		.title{
			padding-bottom:24px;
			font-size: 42px;
		}
	}
	/*块2*/
	.block_2{
		height: 1898px;
		padding: 100px 0 20px 0;
		.block_2_el{
			.btn_box{
				margin: 42px 0 42px 20px;
			}
			.txt{
				padding: 0 20px;
				font-size: 18px;
			}
			.tit{
				padding: 20px 20px 16px 20px;
				font-size:24px;
			}
			img.bg{
				width: 100%;
			}
		}
	}
	/*块1*/
	.block_1{
		position: relative;
		height: 1230px;
		padding: 42px 20px 0 20px;
		.mark{
			position: absolute;
			top: 0;
			left: 0;
			z-index: -1;
			width: 100%;
			height: 90%;
			background-image: linear-gradient(180deg, #FFFFFF 20%, #F1ECE6 100%);
		}
		.block_1_el{
			background-color: #FFFFFF;
			box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
			.btn_box{
				margin: 42px 0 50px 0;
			}
			.txt{
				padding: 0 16px;
				font-size: 18px;
			}
			.tit{
				padding: 20px 16px 16px 16px;
				font-size:24px;
			}
			img.bg{
				width: 100%;
			}
		}
	}
}
</style>
